import request from "@/axios.js";

export default class Keywords {

    constructor(ps) {
    }
    /**
     * Get list of keywords for a domain
     * @param {String} domain 
     * @param {Number} location_code 
     * @returns 
     */
    static getKeywordsForDomain(domain, location_code){
        return new Promise((resolve, reject) => {
            request.get(
                `/dataforseo/getKeywordsForDomain?domain=${domain}&location_code=${location_code}`
            )
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        }	);

    }
    /**
     * Get the number of crossover urls for a keywords
     * @param {Array} keywords
     * @param {Number} locationCode 
     * @param {String} languageCode - fr/en/...
     * @returns 
     */
    static getCrossoverUrlsForKeywords(keywords, locationCode, languageCode){
        return new Promise((resolve, reject) => {
            request.post(
                `/dataforseo/keywords/cossoverUrls`,
                {
                    "language_code": languageCode,
                    "location_code": locationCode,
                    // "urls" : urls,
                    "keywords": keywords
                }

            )
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        }	);

    }
    static async addKeywordsCategory(body) {
        return new Promise((resolve, reject) => {
            request.post("keywords/keywordCategories/", body)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async getKeywordsCategories() {
        return new Promise((resolve, reject) => {
            request.get("keywords/keywordCategories/")
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async updateKeywordCategory(body, id){
        return new Promise((resolve, reject) => {
            request.patch("keywords/keywordCategory/" + id, body)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async delKeywordsCategories(id) {
        return new Promise((resolve, reject) => {
            request.delete("keywords/keywordCategory/"+id)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async getTopKeywords(id) {
        return new Promise((resolve, reject) => {
            request.get("keywords/getTopKeywords/" + id)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async addTopKeywords(keywords, id){
        return new Promise((resolve, reject) => {
            request.post("keywords/addTopKeywords/" + id, keywords)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async updateTopKeyword(body, id){
        return new Promise((resolve, reject) => {
            request.patch("keywords/topKeyword/" + id, body)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async deleteTopKeywords(id){
        return new Promise((resolve, reject) => {
            request.delete("keywords/topKeyword/" + id)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async deleteTopKeywordsByName(keyword, id){
        return new Promise((resolve, reject) => {
            request.delete(`keywords/topKeywordByName?keyword=${keyword}&socId=${id}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async deleteTopKeywordsBatch(ids){
        return new Promise((resolve, reject) => {
            request.post("keywords/topKeyword/delete_batch/", ids)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async getKeywordsSubcategories() {
        return new Promise((resolve, reject) => {
            request.get("keywords/keywordSubCategories")
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async addKeywordsSubcategory(payload) {
        return new Promise((resolve, reject) => {
            request.post("keywords/keywordSubCategories", payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async delKeywordsSubcategory(id) {
        return new Promise((resolve, reject) => {
            request.delete("keywords/keywordSubCategory/" + id)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    static async updateKeywordsSubcategory(payload, id) {
        return new Promise((resolve, reject) => {
            request.patch("keywords/keywordSubCategory/" + id, payload)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    
}
